export enum TagDataType {
    ZipCode,
    FinancingName
}


export const TagDataForTagType: {[id: number]: TagDataType[] } = {
  0: [TagDataType.ZipCode, TagDataType.FinancingName],
}


export const TagDataTypeValues: { [id: number]: string } = {
    0: 'Código Postal',
    1: 'Nombre de Financiera'
  };
  
  export namespace TagDataType {
    export function values() {
      let values = Object.keys(TagDataType)
        .filter((type) => isNaN(<any>type) && type !== 'values')
        .map((key, index) => {
          return { key: TagDataTypeValues[index], value: index };
        });
      return values.filter((x) => x.value != 0);
    }
  }